export type TOrderSide = "before" | "after";

const SIDE_CLASS_NAMES: Record<
  TOrderSide,
  { moved: string; onlyHere: string }
> = {
  before: {
    moved: "entityProperty__chip--moved-from",
    onlyHere: "entityProperty__chip--removed",
  },
  after: {
    moved: "entityProperty__chip--moved-to",
    onlyHere: "entityProperty__chip--added",
  },
};

/** A station in the old or new order: grey when it stayed, coloured when it was dragged, came in or left. */
export const getOrderChipClassName = ({
  item,
  side,
  moved,
  otherSide,
}: {
  item: string;
  side: TOrderSide;
  moved: Set<string>;
  otherSide: Set<string>;
}): string => {
  const classNames = SIDE_CLASS_NAMES[side];
  if (!otherSide.has(item)) {
    return `entityProperty__chip ${classNames.onlyHere}`;
  }
  return moved.has(item)
    ? `entityProperty__chip ${classNames.moved}`
    : "entityProperty__chip";
};
